import React from 'react';
import { PageSection } from 'src/components/selfService/layout/PageSection/PageSection';
import { useBalanceAccountInfo } from 'src/components/selfService/common/Balance/hooks/useBalanceAccountInfo';
import { CreditCardPaymentSection } from './CreditCardPaymentSection/CreditCardPaymentSection';
import { BalancePaymentMethodsSection } from './BalancePaymentMethodsSection/BalancePaymentMethodsSection';

export type AccountPaymentSectionProps = {
  corpId: string;
  isInternalAdminUser: boolean;
};

export function AccountPaymentSection({
  corpId,
  isInternalAdminUser,
}: AccountPaymentSectionProps): JSX.Element {
  const { isBalanceAccount } = useBalanceAccountInfo();

  return (
    <PageSection>
      {isBalanceAccount ? (
        <BalancePaymentMethodsSection />
      ) : (
        <CreditCardPaymentSection
          corpId={corpId}
          isInternalAdminUser={isInternalAdminUser}
        />
      )}
    </PageSection>
  );
}
